// extracted by mini-css-extract-plugin
export default {"myBtn":"Button_myBtn__V9+Ah","red":"Button_red__ndORu"};